import sdl from '@jds/react-generated-sdl/JDSRatingBar';
import type { JDSRatingBarProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, RatingBarProps } from '../logic';

const Component = (props: RatingBarProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    size = 'undefined',
    labelPosition = 'top_left',
    type = 'interactive',
    disabled = false,
    state = 'undefined',
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { size, labelPosition, type, disabled, state, ...rest },
    'JDSRatingBar',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const RatingBar = withLogic(Component) as React.FC<RatingBarProps> & {
  slotName?: string;
};

RatingBar.displayName = 'RatingBar';
RatingBar.slotName = 'jds_rating_bar';

export { RatingBar, type JDSRatingBarProps };
